let publicUrlPrefix = ''

/*
if (process.env.NODE_ENV == 'development') {
    publicUrlPrefix = 'http://192.168.0.49:8881'
    // window.publicUrlPrefix = 'http://222.222.17.184:8990'
    window.publicUrlPrefix = 'http://192.168.0.49:8881'
} else if (process.env.NODE_ENV == 'test') {
    publicUrlPrefix = 'http://192.168.0.46:70'
    window.publicUrlPrefix = 'http://192.168.0.46:70'
    // publicUrlPrefix = 'http://192.168.2.193:8181'
    // window.publicUrlPrefix = 'http://192.168.2.193:8181'
    // publicUrlPrefix = 'http://222.222.17.184:8990'
    // window.publicUrlPrefix = 'http://222.222.17.184:8990'
} else if(process.env.NODE_ENV == 'production') {
    publicUrlPrefix = 'https://echelianapi.ygxpt.com'
    window.publicUrlPrefix = 'https://echelianapi.ygxpt.com'
}
    */
console.log(process.env.VUE_APP_BASE_URL)
if (process.env.VUE_APP_BASE_URL) {
    publicUrlPrefix = process.env.VUE_APP_BASE_URL
    window.publicUrlPrefix = process.env.VUE_APP_BASE_URL
} else {
    publicUrlPrefix = 'https://echelianapi.ygxpt.com'
    window.publicUrlPrefix = 'https://echelianapi.ygxpt.com'
}


export {publicUrlPrefix}
